import type { ChipProps } from '@mui/material'
import { CardHeader, Stack } from '@mui/material'

import type { CustomChipProps } from '@/components/dataDisplay/CustomChip'
import CustomChip from '@/components/dataDisplay/CustomChip'
import CustomTypography from '@/components/dataDisplay/CustomTypography'

type SectionHeaderProps = Readonly<{
  title: string
  description?: string
  status?: { label: string; color: ChipProps['color']; variant?: CustomChipProps['variant'] }
}>

export function SectionHeader({ title, description, status }: SectionHeaderProps) {
  return (
    <CardHeader
      subheader={
        description ? (
          <CustomTypography color="grey.600" variant="body2">
            {description}
          </CustomTypography>
        ) : undefined
      }
      sx={{ paddingX: 0, paddingTop: 0 }}
      title={
        <Stack alignItems="center" direction="row" gap={1.5}>
          <CustomTypography variant="h6">{title}</CustomTypography>
          {status && (
            <CustomChip color={status.color} label={status.label} size="small" variant={status.variant ?? 'outlined'} />
          )}
        </Stack>
      }
    />
  )
}
